import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from './components/Header';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { HomeText } from './components/HomeText';
import { WhyUs } from './components/WhyUs';
import { Address } from './components/Address';
import { Testimony } from './components/Testimony';

function GetQuote() {
  return (
    <div className="App">
      <Header />
      <HomeText />
      <WhyUs /> 
      <Testimony />
      <Address />     
      <Contact />
      <Footer />
    </div>
  );
}

export default GetQuote;

